import { createActions } from 'redux-actions';

import types from 'state/direct-order-recurring/drop-off/actionTypes';

const { directOrderRecurring } = createActions({
  [types.SET_ADD_DAYS]: (addDays) => ({ addDays }),
});

export default directOrderRecurring;
